import { render } from "./ShopPage.vue?vue&type=template&id=2bff3f75&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"

import "./ShopPage.vue?vue&type=style&index=0&id=2bff3f75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bff3f75"]])

export default __exports__